/**
 * Labstep
 *
 * @module components/Molecule/Pictograms/ActionRemove
 * @desc Action to add pictogram
 */

import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type React from 'react';
import { getUpdatedPubChemBody } from '../ActionAdd/utils';
import type { MoleculeSafetyActionRemoveProps } from './types';

export const MoleculeSafetyActionRemove: React.FC<
  MoleculeSafetyActionRemoveProps
> = ({ parent, type, code, subtype, pubChemMetadata }) => (
  <EntityActionUpdate
    entityName={parent.entityName}
    id={parent.idAttr}
    body={
      getUpdatedPubChemBody(
        parent,
        pubChemMetadata,
        type,
        code,
        'remove',
        subtype,
      ) as any
    }
    actionComponentProps={{
      type: 'icon',
      elementProps: { name: 'times' },
    }}
  />
);
